<template>
  <TabletCharacters :spaceAround="spaceAround">
    <template v-for="(character, index) in itaiji">
      <TabletCharacterImage
        :key="`${character.character}-${index}`"
        :char="character"
        :font="font"
        :src="character.imageUrl"
        :size="size"
        @onClickCharacter="_onClickCharacter(character, index, text)"
      />
    </template>
    <slot name="characters"></slot>
    <div
      class="CharacterSpacer"
      v-if="spaceAfter"
      :style="{ height: `${spaceAfter * size}px` }"
    ></div>
  </TabletCharacters>
</template>

<script>
import TabletCharacters from "./TabletCharacters";
import TabletCharacterImage from "./TabletCharacterImage";
export default {
  components: {
    TabletCharacters,
    TabletCharacterImage,
  },
  data () {
    return {};
  },
  props: {
    font: {
      type: String,
      default: "標準書体",
    },
    size: {
      type: Number,
      default: 25,
    },
    onClickCharacter: {
      type: Function,
      default: () => {},
    },
    spaceAround: {
      type: Boolean,
      default: false,
    },
    spaceAfter: {
      type: Number,
      default: 0,
    },
    itaiji: {
      type: Array,
      default: () => [],
    },
    prefix: {
      type: String,
      default: "",
    },
  },
  created () {},
  computed: {},
  methods: {
    _onClickCharacter (character, characterIndex, text) {
      console.log("_onClickCharacter", text);
      // 現状、位表記は無視したいので、位表記がタップされた場合は処理を中止
      // 将来的に対応する可能性あり
      if (characterIndex >= this.itaiji.length) {
        return false;
      }
      this.$emit("onClickCharacter", {
        character: character.character,
        characterDetail: character,
        characterIndex,
        text,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.Character {
  width: 30px;
}
.Character > * {
  display: inline;
}
.SpaceAround {
  display: flex;
  justify-content: space-around;
}
.CharacterSpacer {
  display: inline-block;
}
</style>
